import React from 'react';
import Navigation from '../../components/navigation'
import {Link} from 'react-router-dom'
import bg1 from './../../images/1.png'
import playOS from './../../images/play_circle_orange_s.png'
import './venue.css'
export default class venue extends React.Component {
    state = {
        picList:[],
        picIndex:0,
        coverIndex:0
    }
    componentWillMount(){
        var list = [bg1,bg1,playOS,bg1,playOS,bg1,bg1]
        this.setState({picList:list})
    }
    togglePic=(index)=>{
        this.setState({picIndex:index})
    }
    toggleCover=(index)=>{
        this.setState({coverIndex:index})
    }
    render(){
        return (
            <main>
                <Navigation tab="train"></Navigation>
                <div className="detail_title"><Link to="/train">培训</Link> / 场馆展示</div>
                <div className="venue">
                    <div className="tab">
                        <Link to="/train/venue/2"><span className={this.props.match.params.id == 2 ? 'active' : ''}>星海店</span></Link>
                        <Link to="/train/venue/1"><span className={this.props.match.params.id == 1 ? 'active' : ''}>久光店</span></Link>
                        <Link to="/train/venue/3"><span className={this.props.match.params.id == 3 ? 'active' : ''}>昆山店</span></Link>
                    </div>
                    {this.props.match.params.id == 1 &&
                    <div className="area">
                        <p>场馆地址：苏州园区旺墩路268号久光百货2楼黄蓝中庭北侧</p>
                        <p>联系电话：0512-67505113</p>
                    </div>
                    }
                    {this.props.match.params.id == 2 &&
                    <div className="area">
                        <p>场馆地址：苏州园区星海街游泳馆3楼</p>
                        <p>联系电话：0521-68733059</p>
                    </div>
                    }
                    {this.props.match.params.id == 3 &&
                    <div className="area">
                        <p>场馆地址：苏州昆山白马泾路46号欧尚超市3楼</p>
                        <p>联系电话：0512-57539589</p>
                    </div>
                    }
                    {this.props.match.params.id == 1 &&
                        <div className="pic">
                            <img src={require('./../../pic/venue_jiu01.jpg')}></img>
                            <img src={require('./../../pic/venue_jiu02.jpg')}></img>
                            <img src={require('./../../pic/venue_jiu03.jpg')}></img>
                            <img src={require('./../../pic/venue_jiu04.jpg')}></img>
                        </div>
                    }
                    {this.props.match.params.id == 2 &&
                        <div className="pic">
                            <img src={require('./../../pic/xinghai01.jpg')}></img>
                            <img src={require('./../../pic/xinghai02.jpg')}></img>
                            <img src={require('./../../pic/xinghai03.jpg')}></img>
                        </div>
                    }
                    {this.props.match.params.id == 3 &&
                        <div className="pic">
                            <img src={require('./../../pic/kunshan01.jpg')}></img>
                            <img src={require('./../../pic/kunshan02.jpg')}></img>
                            <img src={require('./../../pic/kunshan03.jpg')}></img>
                            <img src={require('./../../pic/kunshan04.jpg')}></img>
                        </div>
                    }
                </div>
            </main>
        )
    }
};